import createHeartComponent from "@finn-no/favorite-heart-component";
import { useAdViewMeta } from "src/context/AdViewProviderContext.tsx";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";

const Favorite = () => {
  const { logInId, locale, isMobile, mountOrigin, isPreview } = useAppConfig();
  const meta = useAdViewMeta();
  const Heart = createHeartComponent({
    userId: logInId ?? "",
    baseUri: `${mountOrigin}/favorite-frontend-api`,
    renderServerSide: false,
  });

  if (isPreview) {
    return null;
  }

  return (
    <Heart
      buttonClass="px-12!"
      itemType="Ad"
      itemId={meta.adId}
      isMobile={isMobile}
      variant="button"
      locale={locale as "en" | "nb" | "fi" | "da" | "sv"}
      renderNumFavs
    />
  );
};

export default Favorite;
